import React from "react";
import { FileDownloadOutlined } from "@mui/icons-material";
import Paper from "@components/Paper/Paper";

interface DeficiencyCardProps {
  fileName: string;
  fileUrl: string;
  onDownload?: () => void;
  onPreview?: () => void;
  testId: string;
}

const DeficiencyCard: React.FC<DeficiencyCardProps> = ({
  fileName,
  onDownload,
  onPreview,
  testId,
}) => {
  return (
    <Paper variant="outlined" data-testid={testId}>
      {" "}
      <div className="flex justify-start items-center mb-2 w-full">
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 font-normal underline break-all cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            onPreview?.();
          }}
        >
          {fileName}
        </a>

        <button onClick={onDownload} className="cursor-pointer text-left ml-auto" title="Download">
          <FileDownloadOutlined />
        </button>
      </div>
    </Paper>
  );
};

export default DeficiencyCard;
